import { getLookupList } from "../utils/apiUtils"
import { ENTITY_NAME_KNOWLEDGE_BASE } from "./dbConstants";

export const getListOptions = async(input) => {
  console.log("KnowledgeBaseDAO.getListOptions - input:", input);
  const companyId = input?.companyId || null;
  return getLookupList(ENTITY_NAME_KNOWLEDGE_BASE, { companyId })
}